import {EmployeeStateConstant} from '../constants';
import BioAdmin from 'types/ba/bioAdmin';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationState: LtFramework.IAlertNotificationState = {
	alertNotifications: new Array<LtFramework.IAlertNotification>(),
};

export const EmployeeProfileState: LtFramework.IEmployeeProfileState = {
	employeeProfile: {
		employeeState: EmployeeStateConstant.unknown,
		initialized: false,
	} as LtFramework.IEmployeeProfile,
};

export const BioProfileState: BioAdmin.IBioProfileState = {
	bioProfile: {} as BioAdmin.IBioProfile,
};

export const UrlState: LtFramework.IUrlState = {
	url: {
		initialized: false,
	} as LtFramework.IUrl,
};
